import API from "../helpers/API"

const FidelityController = {
  fetchAll() {
    return API.request("/v1/fidelity/all/website", [], "GET")
  },

  deleteExpiredPoint(expiredPoints) {
    return API.request("/v1/fidelity/customer/many/delete", expiredPoints, "DELETE")
  },
}

export default FidelityController
